import * as React from 'react'
import PaypalExpressComponent from './PaypalExpress'
import { PayPalScriptProvider } from '@paypal/react-paypal-js'
import config from 'config'
import useAccount from 'hooks/account/useAccount/useAccount'

type Props = {
  'data-cy-state'?: string
}

export default function PaypalExpress(props: Props) {
  const account = useAccount()
  const [paypalOrderId, setPaypalOrderId] = React.useState<string | null>(
    () => {
      const cacheS = sessionStorage.getItem('paypal-express')
      if (!cacheS) return null
      const cache = JSON.parse(cacheS)
      return cache.price === account.cart.data.totalPrice ? cache.po : null
    }
  )

  React.useEffect(() => {
    const cacheS = sessionStorage.getItem('paypal-express')
    if (!cacheS) return setPaypalOrderId(null)
    const cache = JSON.parse(cacheS)
    setPaypalOrderId(
      cache.price === account.cart.data.totalPrice ? cache.po : null
    )
  }, [account.cart.data.totalPrice])

  if (!config.modules.paypalExpress) return null
  if (account.loggedIn && !account.context?.isGuest) return null
  if (paypalOrderId) return null

  return (
    <PayPalScriptProvider
      options={{
        clientId: config.modules.paypalExpress.clientId,
        buyerCountry: config.features.devMode ? config.i18n.country : undefined,
        commit: false,
        components: 'buttons',
        currency: config.i18n.currency_ISO,
        disableFunding: 'paylater,mybank,ideal,giropay,eps',
        intent: 'capture',
        locale: config.i18n.locale.replace('-', '_')
      }}
    >
      <PaypalExpressComponent {...props} />
    </PayPalScriptProvider>
  )
}
